import { createFileRoute } from '@tanstack/react-router'
import ModalMessage from 'components/modal-message';
import SuccessIcon from '../../../assets/images/Success';
import { useContext, useEffect } from 'react';
import { ElectronicSignatureContext } from '../../-src/context/electronic-signature.context';
import { savePersonData } from '../../-src/actions/person-data.action';
import { saveApplicationData } from '../../-src/actions/application-data.action';

export const Route = createFileRoute(
  '/_with-appbar/success-video/',
)({
  component: RouteComponent,
})

function RouteComponent() {

  const {dispatch:{personDataDispatch, applicationDataDispatch}} = useContext(ElectronicSignatureContext);
  const { parametro }: { parametro: string } = Route.useSearch();
  const parametroJson = JSON.parse(atob(parametro));

  useEffect(()=>{
      sessionStorage.clear();
      personDataDispatch(savePersonData({documentNumber:"", documentType: 0, uniqueId: "", signatoryType: 0}));
      applicationDataDispatch(saveApplicationData({tokenSesion: "", codigoAplicacion: 0, idSolicitud: 0}));
    },[])

  return <div className='flex flex-col gap-10 items-center justify-center h-screen '>
    <ModalMessage isOpen={true} title="¡Gracias por confiar en nosotros!" messageBody="Pronto recibirás un correo con mayor detalle de tu compra." 
      iconElement={<SuccessIcon />} solicitudeNumber={parametroJson?.numeroSolicitud} />
  </div>
}
